import addToCartProductFooter from './add-to-cart-product-footer';
import $ from 'jquery';

(function (document, $, undefined) {

	const productFooter = {};

	productFooter.init = function () {
		if ($('.product-footer-data').length) {
			addToCartProductFooter();
		}
	};

	$(document).ready(function () {
		productFooter.init();
	});

})(document, jQuery);
